@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!--#region Label Top -->

  @if (settings().labelPosition === 'top') {
    <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
  }
  <ng-content select="label[slot-top]"></ng-content>

  <!--#endregion Label Top -->

  <div uiinputcontent [class]="contentCssClass()" (click)="focusin()">
    <!--#region Default Icon Left -->

    @if (settings().defaultIconSlot === 'left') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-left]"></ng-content>

    <!--#endregion Default Icon Left -->

    <!--#region Label Embedded -->

    @if (settings().labelPosition === 'embedded') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-embedded]"></ng-content>

    <!--#endregion Label Embedded -->

    <!--#region Input -->

    @if (multiline()) {
      <textarea
        [ngClass]="isExpanded() ? 'expanded' : 'collapsed'"
        [attr.class]="inputCssClass()"
        [style.max-height.px]="settings().maxExpandedHeight?.toString()"
        #uiValueRef
        uivalue
        rows="1"
        [value]="formattedValue()"
        [placeholder]="placeholder()"
        (blur)="focusout()"
        (input)="updateSize()"
        (keyup)="emitInput(uiValueRef.value)"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="uiValueRef.blur()"
      ></textarea>
    } @else {
      <input
        [class]="inputCssClass()"
        #uiValueRef
        uivalue
        [value]="formattedValue()"
        [title]="type() !== 'password' ? formattedValue() : ''"
        [type]="type()"
        [attr.placeholder]="placeholder()"
        (focus)="focusin()"
        (blur)="focusout()"
        (keyup)="emitInput(uiValueRef.value)"
        (keyup.enter)="uiValueRef.blur()"
        [disabled]="settings().disabled"
      />
    }

    <!--#endregion Input -->

    <!--#region Tools -->

    @if (!settings().disabled) {
      <div uitoolstrip>
        <ng-container #uiToolsDefaultRef>
          @if (
            settings().showClearButton &&
            !isNil(value()) &&
            !settings().disabled
          ) {
            <btn
              uihovertool
              uicleartool
              uiunpermissioned
              class="unstyled xxs"
              [settings]="{
                icon: ICONS.CLOSE_SMALL,
                iconOnly: true,
              }"
              (click)="clearValue($event); $event.stopImmediatePropagation()"
            >
            </btn>
          }
        </ng-container>
        <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
        <ng-template #uiToolsCodeRef></ng-template>
      </div>
    }

    <!--#endregion Tools -->

    <!--#region Default Icon Right -->

    @if (settings().defaultIconSlot === 'right') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-right]"></ng-content>

    <!--#endregion Default Icon Right -->
  </div>

  <!--#region Footer -->

  @switch (state()) {
    @case ('error') {
      <span
        uifooter
        uistate="error"
        class="cursor-help"
        [title]="errors().join('\r\n')"
        >{{
          errors().length > 1
            ? errors().at(0) +
              ' (' +
              (errors().length - 1).toString() +
              ' more)'
            : errors().at(0)
        }}</span
      >
    }
    @case ('warning') {
      <span
        uifooter
        uistate="warning"
        class="cursor-help"
        [title]="warnings().join('\r\n')"
        >{{
          warnings().length > 1
            ? warnings().at(0) +
              ' (' +
              (warnings().length - 1).toString() +
              ' more)'
            : warnings().at(0)
        }}</span
      >
    }
    @default {
      @if (showCharCount() && !isNil(value())) {
        <span uifooter>characters: {{ valueLength() }}</span>
      }
    }
  }

  <!--#endregion Footer  -->

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    <label
      uipopuptrigger
      [class.hidden]="!settings().label && !settings().labelTip"
      [attr.slot-embedded]="
        settings().labelPosition === 'embedded' ? true : undefined
      "
      [label]="labelFormatted()"
      [labelTip]="labelTip()"
      [state]="state()"
    >
    </label>
  </ng-template>

  <!-- Default Icon Template-->
  <ng-template #uiDefaultIconTemplateRef>
    @if (
      (!settings().hideDefaultIcon &&
        multiline() &&
        !settings().disableExpandToggle) ||
      settings().defaultIcon
    ) {
      <icon
        [attr.uidefaulticon]="settings().defaultIconSlot"
        [iconDefinition]="
          settings().defaultIcon ??
          (isExpanded() ? ICONS.COLLAPSE : ICONS.EXPAND)
        "
        [attr.title]="
          multiline()
            ? isExpanded()
              ? 'Turn auto collapse off'
              : 'Turn auto collapse on'
            : undefined
        "
        (click)="toggleExpand(!isExpanded())"
      ></icon>
    }
  </ng-template>

  <!--#endregion Templates -->
}
